// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors, Action Creators, Operator
import { eulaSigned$, postEulaStatus } from 'hfty-auth'
import { removeCredentials } from 'fc-auth'

// Operator
type Props = {
  eulaSigned: boolean,
}

const mapStateToProps = function (state: Object): Props {
  return {
    eulaSigned: eulaSigned$(state),
  }
}

const mapDispatchToProps = function (dispatch: Dispatch<*>): Actions {
  return {
    actions: bindActionCreators({
      postEulaStatus,
      logout: removeCredentials,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
